import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import { DateFormat } from '../../../../../../utils/date';

import { PROMOTION_STATUS } from '../../../../../Model/Promotion';
import texts from './texts';

const getColumns = ({
  statusRenderCell,
  actionsRenderCell,
}) => (
  [
    {
      field: 'description',
      quickSearch: true,
      headerName: texts.columns.description,
      flex: 1,
      renderCell: ({ row }) => (row.description
        ? ReactHtmlParser(row.description)
        : '-'),
    },
    {
      field: 'startDate',
      headerName: texts.columns.startDate,
      flex: 1,
      type: 'datetime',
      valueGetter: ({ row }) => row.startDate || null,
      renderCell: ({ row }) => (row.startDate
        ? moment(row.startDate).format(DateFormat.DATE_FORMAT_COMMA)
        : '-'),
    },
    {
      field: 'endDate',
      headerName: texts.columns.endDate,
      type: 'datetime',
      flex: 1,
      valueGetter: ({ row }) => row.endDate || null,
      renderCell: ({ row }) => (row.endDate
        ? moment(row.endDate).format(DateFormat.DATE_FORMAT_COMMA)
        : '-'),
    },
    {
      field: 'status',
      headerName: texts.columns.status,
      flex: 1,
      renderCell: statusRenderCell,
      valueGetter: ({ row }) => {
        const isOngoing = row.isOngoing();
        return isOngoing ? PROMOTION_STATUS.ONGOING : PROMOTION_STATUS.UPCOMING;
      },
    },
    {
      field: 'actions',
      headerName: texts.columns.actions,
      sortable: false,
      filterable: false,
      flex: 1,
      renderCell: actionsRenderCell,
    },
  ]
);

export default getColumns;
